Skye.Config.Components.Process.scrollToFirstActiveInput = false;

Skye.Config.Components.Datepicker.onChange = () => {
    const datePopper = document.querySelector(".react-datepicker-popper");
    
    if(datePopper) {datePopper.style.display = "none"};
}